import _export from '../internals/export.js';
import mathLog1p from '../internals/math-log1p.js';

var $ = _export;
var log1p = mathLog1p; // `Math.log1p` method
// https://tc39.es/ecma262/#sec-math.log1p

$({
  target: 'Math',
  stat: true
}, {
  log1p: log1p
});
